import React from "react";
import CurrentStep from "shared/components/embedded-stepper/current-step";
import NextStep from "shared/components/embedded-stepper/next-step";
import LineStepper from "shared/components/embedded-stepper/line-stepper";
import DoneStep from "shared/components/embedded-stepper/done-step";
import classNames from "classnames";
import "./style.scss";

const Stepper = ({ primaryColor, stepperPages, lineStepperClass }) => {
  const doneSteps = stepperPages.doneSteps ? stepperPages.doneSteps : [];
  const nextSteps = stepperPages.nextSteps ? stepperPages.nextSteps : [];

  return (
    <React.Fragment>
      <nav aria-label="Progress">
        <ol className="stepper-root">
          {doneSteps.map((step) => (
            <DoneStep key={step.title} title={step.title} primaryColor={primaryColor} />
          ))}
          <CurrentStep
            title={stepperPages.currentStep.title}
            primaryColor={primaryColor}
          />
          {nextSteps.map((step) => (
            <NextStep key={step.title} title={step.title} />
          ))}
        </ol>
      </nav>
      <nav className="line-root" aria-label="Line Progress">
        <div
          aria-hidden="true"
          className={classNames("stepper-hr", {
            [lineStepperClass]: !!lineStepperClass,
          })}
        />
        <ol className="list">
          {doneSteps.map((step) => {
            return <LineStepper key={step.title} step="done" />;
          })}
          <LineStepper step="current" />
          {nextSteps.map((step) => {
            return <LineStepper key={step.title} step="next" />;
          })}
        </ol>
      </nav>
    </React.Fragment>
  );
};

export default Stepper;
